
import Settings from "../../../assets/duotone/Settings.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SettingsIcon({ className, dataTestid = "SettingsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Settings data-testid={dataTestid} className={classes} {...rest} />
  );
}
